import VueApexCharts from 'vue-apexcharts'
import HomeHeader from "../main/HomeHeader";
import PassengersDashboard from './components/PassengersDashboard';
import CashiersDashboard from './components/CashiersDashboard';
import RoutesDashboard from './components/RoutesDashboard';
import TripsDashboard from "./components/TripsDashboard";

Vue.component('apexchart', VueApexCharts);

export default {
    components: {HomeHeader, VueApexCharts, PassengersDashboard, CashiersDashboard, RoutesDashboard, TripsDashboard},
    data() {
        return {
            sixthSeries: [{
                name: 'Inflation',
                data: [2.3, 3.1, 4.0, 10.1, 4.0, 3.6, 3.2, 2.3, 1.4, 0.8, 0.5, 0.2]
            }],
            sixthOptions: {
                chart: {
                    height: 350,
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        plotOptions: {
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        },
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val + "%";
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },

                xaxis: {
                    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                        offsetY: -35,

                    }
                },
                fill: {
                    gradient: {
                        shade: 'light',
                        type: "horizontal",
                        shadeIntensity: 0.25,
                        gradientToColors: '#BED1E6',
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 0.5,
                        stops: [50, 0, 100, 100]
                    },
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                        formatter: function (val) {
                            return val + "%";
                        }
                    }

                }
            }
        }
    },
    created() {
        this.getPassengersData();
    },
    methods: {
        getPassengersData() {
            this.$api.get('dashboard.passengers')
                .then(res => {
                    let data = res.data;
                })
        }
    }
}
